import { showToast } from "controls/global/stewart-toast";
import { insertPolicyTransactionStage, PolicyTransactionStageChange } from "utils/api/policyTransactionApi";
import { StageType } from "utils/data/enum";

export const handleBulkReturnPolicyTransaction = async (identityKeys: string[], reason: string, stage: StageType) => {
    let returnQueuePayload: PolicyTransactionStageChange = {
        PolicyTransactionListID: identityKeys.join(","),
        IsForcePromoted: 0,
        StageTypeCode: stage,
        StageChangeReason: reason
    }
    const result = await insertPolicyTransactionStage(returnQueuePayload);
    if (result) {
        showToast({
            type: "success",
            message: `Returned ${identityKeys.length} record${identityKeys.length !== 1 ? "s" : ""} to the ${stage} queue`,
        });
    }
    else {
        showToast({
            type: "error",
            message: `Failed to return ${identityKeys.length} record${identityKeys.length !== 1 ? "s" : ""} to the ${stage} queue`,
        });
    }
    return result;
}